import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaArrowRight, 
  FaStar, 
  FaHeart, 
  FaShoppingBag, 
  FaEye,
  FaCouch,
  FaFilter,
  FaSearch,
  FaHome
} from 'react-icons/fa';

const LivingRoom = () => {
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const products = [
    {
      id: 1,
      name: 'Modern Fabric Sofa',
      image: 'https://i5.walmartimages.com/asr/8727df34-10f7-41a0-85a8-98d352d42451.c4513eb048f9d374b402c9ecc319257e.jpeg',
      discount: '28% OFF',
      rating: 4.8,
      category: 'sofa',
      description: 'Comfortable fabric sofa with wooden frame'
    },
    {
      id: 2,
      name: 'Leather Recliner',
      image: 'https://tse1.mm.bing.net/th/id/OIP.z1vG2pXU-9HiRj8-dojZ-QHaHG?rs=1&pid=ImgDetMain&o=7&rm=3',
      discount: '27% OFF',
      rating: 4.9,
      category: 'recliner',
      description: 'Premium leather recliner with adjustable positions'
    },
    {
      id: 3,
      name: 'Wooden Coffee Table',
      image: 'https://tse3.mm.bing.net/th/id/OIP.SF2KVFvyaXuKHKyB1OiLMQHaIi?rs=1&pid=ImgDetMain&o=7&rm=3',
      discount: '30% OFF',
      rating: 4.7,
      category: 'table',
      description: 'Solid wood coffee table with storage'
    },
    {
      id: 4,
      name: 'TV Unit Stand',
      image: 'https://tse3.mm.bing.net/th/id/OIP.Cy-B5FpTf95yHooAnXXx_gAAAA?w=325&h=325&rs=1&pid=ImgDetMain&o=7&rm=3',
      discount: '32% OFF',
      rating: 4.6,
      category: 'tvunit',
      description: 'Modern TV unit with ample storage space'
    },
    {
      id: 5,
      name: 'Bookshelf Cabinet',
      image: 'https://i5.walmartimages.com/asr/f1b24128-26af-4e35-bd44-ce21a9fb059b_1.b3abc15a6ff8974c7f9e5c2297245f2a.jpeg?odnWidth=1000&odnHeight=1000&odnBg=ffffff',
      discount: '29% OFF',
      rating: 4.8,
      category: 'storage',
      description: 'Wooden bookshelf with 5 shelves'
    },
    {
      id: 6,
      name: 'Corner Sofa Set',
      image: 'https://5.imimg.com/data5/PK/PS/CT/SELLER-88845746/stylish-corner-sofa-sets-1000x1000.jpg',
      discount: '28% OFF',
      rating: 4.9,
      category: 'sofa',
      description: 'L-shaped corner sofa for family gatherings'
    },
    {
      id: 7,
      name: 'Floor Lamp',
      image: 'https://i5.walmartimages.com/asr/42a02508-be78-4b93-8a96-e4fe9353f69e.4820a01ef4d5b6feb7ded07ce083d682.jpeg',
      discount: '33% OFF',
      rating: 4.5,
      category: 'lighting',
      description: 'Elegant floor lamp for ambient lighting'
    },
    {
      id: 8,
      name: 'Area Rug',
      image: 'https://tse4.mm.bing.net/th/id/OIP.bBeMykE9OldGFk-yXEEYNwHaHa?rs=1&pid=ImgDetMain&o=7&rm=3',
      discount: '36% OFF',
      rating: 4.7,
      category: 'rug',
      description: 'Handwoven area rug for living room'
    },
    {
      id: 9,
      name: 'Wall Art Set',
      image: 'https://tse1.explicit.bing.net/th/id/OIP.ai9M_RwD1pp4QKI9qeHOVwHaJT?rs=1&pid=ImgDetMain&o=7&rm=3',
      discount: '37% OFF',
      rating: 4.6,
      category: 'decor',
      description: 'Set of 3 canvas wall arts'
    },
    {
      id: 10,
      name: 'Cushion Covers',
      image: 'https://tse1.mm.bing.net/th/id/OIP.90JE30llhaEs9VpIOxDTJwHaHa?rs=1&pid=ImgDetMain&o=7&rm=3',
      discount: '50% OFF',
      rating: 4.4,
      category: 'decor',
      description: 'Set of 4 cotton cushion covers'
    },
    {
      id: 11,
      name: 'Center Table',
      image: 'https://5.imimg.com/data5/SELLER/Default/2022/6/ON/PM/XL/38372272/1-1000x1000.jpg',
      discount: '33% OFF',
      rating: 4.5,
      category: 'table',
      description: 'Modern center table with glass top'
    },
    {
      id: 12,
      name: 'Showcase Cabinet',
      image: 'https://images.livspace-cdn.com/w:3840/plain/https://d3gq2merok8n5r.cloudfront.net/abhinav/ond-1634120396-Obfdc/1-2025-1736068988-NDPD1/jfm-1736069001-9OxTK/crockery-unit-1736407797-WvSAW/cr-1737975204-gA2Uz.jpg',
      discount: '30% OFF',
      rating: 4.8,
      category: 'storage',
      description: 'Glass showcase for displaying artifacts'
    }
  ];

  const filters = [
    { id: 'all', name: 'All Products', icon: <FaHome /> },
    { id: 'sofa', name: 'Sofas', icon: <FaCouch /> },
    { id: 'table', name: 'Tables', icon: <FaShoppingBag /> },
    { id: 'storage', name: 'Storage', icon: <FaShoppingBag /> },
    { id: 'lighting', name: 'Lighting', icon: <FaShoppingBag /> },
    { id: 'decor', name: 'Decor', icon: <FaShoppingBag /> }
  ];

  const filteredProducts = products.filter(product => {
    const matchesFilter = selectedFilter === 'all' || product.category === selectedFilter;
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         product.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative h-64 bg-gradient-to-r from-pink-500 to-blue-500 overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="absolute inset-0 flex items-center justify-center text-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Living Room Collection
            </h1>
            <p className="text-lg text-white/90 max-w-2xl mx-auto px-4">
              Discover comfortable and stylish furniture for your living space
            </p>
          </div>
        </div>
      </div>

      {/* Filters Section */}
      <div className="container mx-auto px-4 py-8">
        {/* Search Bar */}
        <div className="max-w-md mx-auto mb-8">
          <div className="relative">
            <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search products..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-4 py-3 rounded-full border border-gray-300 focus:outline-none focus:border-pink-500 focus:ring-2 focus:ring-pink-200 transition-all duration-300"
            />
          </div>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {filters.map((filter) => (
            <button
              key={filter.id}
              onClick={() => setSelectedFilter(filter.id)}
              className={`flex items-center gap-2 px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                selectedFilter === filter.id
                  ? 'bg-gradient-to-r from-pink-500 to-blue-500 text-white shadow-lg scale-105'
                  : 'bg-white text-gray-600 hover:text-pink-500 shadow hover:shadow-md'
              }`}
            >
              <span>{filter.icon}</span>
              {filter.name}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredProducts.map((product) => (
            <div key={product.id} className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden">
              {/* Discount Badge */}
              <div className="absolute top-4 left-4 z-10 bg-gradient-to-r from-pink-500 to-blue-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                {product.discount}
              </div>

              {/* Image Container */}
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center gap-3">
                  <button className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-pink-500 hover:bg-pink-500 hover:text-white transition-all duration-300">
                    <FaShoppingBag size={16} />
                  </button>
                  <button className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-blue-500 hover:bg-blue-500 hover:text-white transition-all duration-300">
                    <FaHeart size={16} />
                  </button>
                  <button className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-purple-500 hover:bg-purple-500 hover:text-white transition-all duration-300">
                    <FaEye size={16} />
                  </button>
                </div>
              </div>

              {/* Product Info */}
              <div className="p-5">
                <h3 className="text-base font-semibold text-gray-800 mb-1 group-hover:text-pink-500 transition-colors duration-300">
                  {product.name}
                </h3>
                <p className="text-xs text-gray-500 mb-2 line-clamp-1">{product.description}</p>
                
                {/* Rating */}
                <div className="flex items-center gap-1 mb-3">
                  <div className="flex">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className={`text-xs ${i < Math.floor(product.rating) ? 'text-yellow-400' : 'text-gray-300'}`} />
                    ))}
                  </div>
                  <span className="text-xs text-gray-500">({product.rating})</span>
                </div>

                {/* Price */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2">
                    <span className="text-lg font-bold text-gray-800">{product.price}</span>
                    <span className="text-xs text-gray-400 line-through">{product.oldPrice}</span>
                  </div>
                </div>

                {/* Add to Cart Button */}
                <button className="w-full py-2.5 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-lg text-sm font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300">
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* No Results Message */}
        {filteredProducts.length === 0 && (
          <div className="text-center py-16">
            <p className="text-xl text-gray-500">No products found matching your criteria.</p>
          </div>
        )}

        {/* Load More Button */}
        {filteredProducts.length > 0 && (
          <div className="text-center mt-12">
            <button className="px-8 py-3 bg-white text-pink-500 rounded-full font-semibold shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105 border-2 border-pink-500 hover:bg-pink-500 hover:text-white">
              Load More Products
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LivingRoom;